import * as React from 'react';
import * as Api from '../../../../api';
import { TApiParameter } from '../../../../api/endpoints/Parameter';
import { TApiSet } from '../../../../api/endpoints/Set';
import { groupBy, map, uniq } from 'lodash';
import { TApiSubset } from '../../../../api/endpoints/Subset';
import Button from './Button';
import { useState, Fragment, useEffect } from 'react';
import SubsetButton from './SubsetButton';
import SubsetTypes from "../../../../utils/SubsetTypes";

interface ISubsetListProps {
  set: TApiSet;
  availableSubsetIds: Array<TApiSubset['id']>;
  onSubsetSelect: (subset: TApiSubset) => void;
}

const SubsetList = (props: ISubsetListProps) => {
  const { set, availableSubsetIds, onSubsetSelect } = props;

  const subsetsByType = groupBy(set.subsets, subset => subset.type);

  return (
    <Fragment>
      {/*<button className="btn__links" onClick={this.props.goBack}>*/}
      {/*  Go back*/}
      {/*</button>*/}

      <h2 className="products__set-name not-desktop">Set {set.name}: {set.description}</h2>

      {
        map(subsetsByType, (subsets, type) => {
          return (
            <div className="products__type" key={type}>
              <h3 className="products__type-title">{SubsetTypes.humanize(type)}</h3>
              {
                subsets.map(subset => (
                  <SubsetButton
                    key={subset.id}
                    subset={subset}
                    isAvailable={availableSubsetIds.length === 0 || availableSubsetIds.includes(subset.id)}
                    onClick={() => onSubsetSelect(subset)}
                  />
                ))
              }
            </div>
          );
        })
      }
    </Fragment>
  );
};

interface IProps {
  sets: Array<TApiSet>,
  params: Array<TApiParameter>,
  onSubsetSelect: (subset: TApiSubset) => void
}

/**
 * Displays all sets grouped by category.
 */
const ProductSelectPanels = (props: IProps) => {
  const { sets, params, onSubsetSelect } = props;
  const setsByCategory = groupBy(sets, set => set.category);
  const [selectedSet, setSelectedSet] = useState<TApiSet | null>(null);
  const [subsetsByParams, setSubsetsByParams] = useState<Array<TApiSubset>>([]);

  const paramShortnames = params.map(param => param.shortname);
  useEffect(() => {
    Api.Subset.list({
      paramShortnames
    }).then(setSubsetsByParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramShortnames.join(',')]);

  const availableSetIds = uniq(subsetsByParams.map(subset => subset.set_id));
  const availableSubsetIds = subsetsByParams.map(subset => subset.id);

  return (
    <div className="products__wrap">
      <div className={'products__panel sets ' + (selectedSet ? '' : 'open')}>
        {
          map(setsByCategory, (setsInCategory, category) => (
            <div className="products__type" key={category}>
              <h2 className="products__type-title">{category}</h2>
              {
                setsInCategory.map(set => (
                  <Button
                    key={set.id}
                    isAvailable={availableSetIds.includes(set.id)}
                    set={set}
                    isSelected={selectedSet?.id === set.id}
                    onClick={() => setSelectedSet(set)}
                  />
                ))
              }
            </div>
          ))
        }
      </div>
      <div className={'products__panel subsets ' + (selectedSet ? 'open' : '')}>
        {
          selectedSet &&
          <SubsetList set={selectedSet} availableSubsetIds={availableSubsetIds} onSubsetSelect={onSubsetSelect} />
        }
      </div>
    </div>
  );
};

export default ProductSelectPanels;
